export default {
    metric_1: 'Number',
    metric_2: 'Percent',
    // metric_2_default is required as a source of truth because metric_2 gets mutated
    // by updateLocaleWith(). Without it, we cannot reset metric_2 back to "Percent"
    // after switching away from GBD/Race&Ethnicity data projects.
    metric_2_default: 'Percent',
    metric_2_data_project_1: 'Percent of All-Cause',
    metric_2_data_project_8: 'Percent of All-Population',
    metric_3: 'Rate',
    metric_4: 'Rank',
    metric_5: 'Years',
    metric_6: 'p-value',
    metric_7: 'MDG p-value',
    metric_8: 'Probability of death',
    metric_9: 'Index score',
    metric_12: 'Proportion',
    metric_65: 'Cumulative new cases',
    metric_10001: 'Percentage points',

    long_metric_undefined: '',
    long_metric_1: 'Number',
    long_metric_2: 'Percent',
    long_metric_2_default: 'Percent',
    long_metric_2_data_project_1: 'Percent of All-Cause',
    long_metric_2_data_project_8: 'Percent of All-Population',
    long_metric_3: 'Rate (per 100,000)',
    long_metric_4: 'Rank',
    long_metric_5: 'Years',
    long_metric_6: 'p-value',
    long_metric_7: 'MDG p-value',
    long_metric_8: 'Probability of death',
    long_metric_9: 'Index score',
    long_metric_12: 'Proportion',
    long_metric_65: 'Cumulative new cases',
};
